/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sanction_Escalation_Needs_SubcategoryInputs */



/**
* | output |
* | --- |
* | "{count} prior sanction(s) in this category — select a subcategory to track escalation" |
*
* @param {Sanction_Escalation_Needs_SubcategoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_escalation_needs_subcategory = /** @type {((inputs: Sanction_Escalation_Needs_SubcategoryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Escalation_Needs_SubcategoryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} sanction(s) antérieure(s) dans cette catégorie — sélectionnez une sous-catégorie pour suivre l'escalade`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} sanción/es anterior/es en esta categoría — seleccione una subcategoría para hacer seguimiento de la escalada`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} sanção/ões anterior/es nesta categoria — selecione uma subcategoria para acompanhar a escalada`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} sanzione/i precedente/i in questa categoria — seleziona una sottocategoria per tracciare l'escalation`)
	return /** @type {LocalizedString} */ (`${i?.count} prior sanction(s) in this category — select a subcategory to track escalation`)
});